<template lang="html">
    <section class="edit-ship-order">
        <loader :loading="loading"></loader>
        <div class="edit-ship-order-content">
            <h1>{{ $t("orders.shipOrder.title") }}</h1>
            <p>{{ $t("orders.shipOrder.textHeader") }}</p>
            <div class="edit-ship-order-form">
                <div class="row">
                    <div class="col-lg-8 col-md-12 col-xs-12 input-shipping">
                        <div class="input-shipping-method edit-ship-order-input">
                            <label class="col-lg-4 col-md-4 col-xs-12 fleft">{{ $t("orders.tableOrder.labelShippingMethod") }} :</label>
                            <select class="col-lg-8 col-md-8 col-xs-12 fleft" v-model="order.orderShippingMethod.id">
                                <option v-for="shippingMethod in shippingMethods" :value="shippingMethod.id" :key="shippingMethod.id">
                                    {{ shippingMethod.name }}
                                </option>
                            </select>
                        </div>
                        <div class="input-shipping-reference edit-ship-order-input">
                            <label class="col-lg-4 col-md-4 col-xs-12 fleft">{{ $t("orders.tableOrder.labelShippingReference") }} :</label>
                            <input class="col-lg-8 col-md-8 col-xs-12 fleft" type="text" v-model="form.shippingReference" />
                        </div>
                        <div class="input-shipping-comment edit-ship-order-input">
                            <label class="col-lg-4 col-md-4 col-xs-12 fleft">{{ $t("orders.tableOrder.labelShippingComments") }} :</label>
                            <textarea class="col-lg-8 col-md-8 col-xs-12 fleft" v-model="form.shippingComments" rows="4" cols="40" />
                        </div>
                        <div class="col-lg-8 col-md-8 col-xs-12 fright">
                            <button class="btn btn-client fleft" @click.prevent="hideModal();">{{ $t("actions.cancel") }}</button>
                            <button class="btn btn-client2 fright" @click.prevent="updateShipOrder();">{{ $t("actions.confirm") }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script lang="js">
import {mapGetters, mapActions} from 'vuex'
import loader from '../../loader/loader'

export default {
    name: 'edit-ship-order',
    components: {loader},
    props: [
        'action'
    ],
    data () {
        return {
            error: false,
            loading: false,
            form: {
                shippingReference: "",
                shippingComments: ""
            }
        }
    },
    watch: {
    },
    created () {
    },
    computed: {
        ...mapGetters("order", {
            order: "details/getOrder",
            shippingMethods: "details/shippingMethods"
        })
    },
    methods: {
        ...mapActions("order", {
            shipOrder: "details/shipOrder"
        }),
        async updateShipOrder() {
            let shipOrderObj = {
                orderShippingMethod: {
                    id: this.order.orderShippingMethod.id
                },
                shippingReference: this.form.shippingReference,
                message: this.form.shippingComments
            };
            if (this.order.orderShippingMethod.id != null) {
                try {
                    this.error = false
                    const res = await this.shipOrder(shipOrderObj)
                    this.$root.$emit('bv::hide::modal', 'ModalShipOrder')
                }
                catch (e) {
                    this.dialogError(e);
                }
                finally {
                    this.loading = false

                }
            }else {
                this.error = true
            }
        },
        /**
         * Function hide Modal
         */
        hideModal: function () {
            this.$root.$emit('bv::hide::modal', 'ModalShipOrder')
        }
    }
}
</script>
<style lang="scss" scoped>
.edit-ship-order {
    &-content {
        text-align: center;
    }
    &-form {
        margin-bottom: 20px;
        text-align: left;
        & .input-shipping {
            margin: 0 auto;
        }
    }
    &-input {
        margin: 15px 0;
        input[type="text"],
        textarea,
        select {
            padding: 5px;
        }
        &:after {
            display: block;
            content: "";
            clear: both;
        }
    }
}
</style>



// WEBPACK FOOTER //
// EditShipOrder.vue?fe2ea4f6